import { ECathegory, EHelpType } from "../types"
import { GAMES } from "./constants"


export const removeWindowSearch = () => {
    window.history.pushState('', document.title, window.location.pathname)
}

export const gameType = () => {
    return GAMES.ZKRATKA
}

export function getPointsText(points: number, cathegory: ECathegory | undefined, helpType: EHelpType | undefined): string {
    switch (gameType()) {
        case GAMES.SIFT: {
            if (cathegory === ECathegory.P && helpType === EHelpType.ABSOLUTE) {
                return ''
            } else {
                return `+${points} minut`
            }
        }
        case GAMES.ZKRATKA: {
            switch (points) {
                case 1: return '-1 bod'
                case 2:
                case 3:
                case 4: return `-${points} body`
                default: return `-${points} bodů`
            }
        }
    }
    return ''
}

export function getCypherPointsText(points: number): string {
    switch (gameType()) {
       
        case GAMES.ZKRATKA: {
            switch (points) {
                case 1: return '1 bod'
                case 2:
                case 3:
                case 4: return `${points} body`
                default: return `${points} bodů`
            }
        }
    }
    return ''
}